import { gradeFromGradYear } from "@/utils/gradeFromGradYear";
import type { AdminAttendanceRow } from "@/types/tables";

export const buildAdminAttendanceRows = (data: any[]): AdminAttendanceRow[] => {
  const rows: AdminAttendanceRow[] = [];

  for (const r of data) {
    for (const s of r.sessions) {
      const records = s.records ?? 0;
      const present = s.present ?? 0;
      const absent = Math.max(0, records - present);
      const rate = records ? Math.round((present / records) * 100) : 0;

      rows.push({
        rotationId: r._id,
        rotationDate: r.date,
        sessionId: s._id,
        sessionName: s.name,
        records,
        present,
        absent,
        rate,
        absentStudents: (s.absentStudents ?? []).map((st: any) => ({
          _id: st._id,
          name: st.name,
          email: st.email,
          gradeLevel: gradeFromGradYear(st.gradYear),
          exploration: st.exploration,
        })),
      });
    }
  }


  return rows;
};
